import { Link } from 'components/Elements';
import { Head } from 'components/Head';
import PropTypes from 'prop-types';
import logo from 'assets/logo.svg';

export const Layout = ({ children, title }) => {
  return (
    <>
      <Head title={title} />
      <div className="relative min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-md px-8 py-10">
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <Link to="/" className="inline-flex items-center gap-2">
              <img src={logo} alt="Ashita Logo" className="h-12 w-auto object-contain" />
            </Link>
          </div>

          {/* Title */}
          <h1 className="text-2xl font-semibold text-gray-900 text-center mb-6 tracking-tight">
            {title}
          </h1>

          {/* Main Content */}
          <div className="space-y-4">{children}</div>

          {/* Footer */}
          <footer className="mt-8 text-center text-xs text-gray-500">
            © {new Date().getFullYear()} Ashita Creatives. All rights reserved.
          </footer>
        </div>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};
